import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PlayButtonComponent } from './play-button.component';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { CurrencyModule } from '@fantaz/shared/ui/currency';
import { SubscriptionModule } from '@fantaz/shared/ui/subscribe';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogModule,
    CurrencyModule,
    SubscriptionModule,
    MatTooltipModule,
  ],
  declarations: [PlayButtonComponent],
  exports: [PlayButtonComponent],
})
export class PlayButtonModule {}
